const data = {
  'Selected': 'Selected: {0} of {1}',
  'Uploading files': 'Uploading {0}% of {1}',
  'File size error': '{0} is too large, please upload files less than {1}',
  'Upload failed': '{0} failed to upload',
  'Per page': '{0} Per Page',
  'Folder': 'Folder',
  'Login failed, please try again': 'Login failed, please try again',
  'Already logged in': 'Already logged in.',
  'Please enter username and password': 'Please enter username and password.',
  'Not Found': 'Not Found',
  'Not Allowed': 'Not Allowed',
  'Please log in': 'Please log in',
  'Unknown error': 'Unknown error',
  'Add files': 'Add files',
  'New': 'New',
  'New name': 'New name',
  'Username': 'Username',
  'Password': 'Password',
  'Login': 'Log in',
  'Logout': 'Log out',
  'Profile': 'Profile',
  'No pagination': 'No pagination',
  'Time': 'Time',
  'Name': 'Name',
  'Size': 'Size',
  'Home': 'Home',
  'Copy': 'Copy',
  'Move': 'Move',
  'Rename': 'Rename',
  'Required': 'Please fill out this field',
  'Zip': 'Zip',
  'Batch Download': 'Batch Download',
  'Unzip': 'Unzip',
  'Delete': 'Delete',
  'Download': 'Download',
  'Copy link': 'Copy link',
  'Done': 'Done',
  'File': 'File',
  'Drop files to upload': 'Drop files to upload',
  'Close': 'Close',
  'Select Folder': 'Select Folder',
  'Users': 'Users',
  'Files': 'Files',
  'Role': 'Role',
  'Cancel': 'Cancel',
  'Paused': 'Paused',
  'Confirm': 'Confirm',
  'Create': 'Create',
  'User': 'User',
  'Admin': 'Admin',
  'Save': 'Save',
  'Read': 'Read',
  'Write': 'Write',
  'Upload': 'Upload',
  'Permissions': 'Permissions',
  'Homedir': 'Home Folder',
  'Leave blank for no change': 'Leave blank for no change',
  'Are you sure you want to do this?': 'Are you sure you want to do this?',
  'Are you sure you want to allow access to everyone?': 'Are you sure you want to allow access to everyone?',
  'Are you sure you want to stop all uploads?': 'Are you sure you want to stop all uploads?',
  'Something went wrong': 'Something went wrong',
  'Invalid directory': 'Invalid directory',
  'This field is required': 'This field is required',
  'Username already taken': 'Username already taken',
  'User not found': 'User not found',
  'Old password': 'Old password',
  'New password': 'New password',
  'Wrong password': 'Wrong password',
  'Updated': 'Updated',
  'Deleted': 'Deleted',
  'Your file is ready': 'Your file is ready',
  'View': 'View',
  'Search': 'Search',
  'Download permission': 'Download',
  'Guest': 'Guest',
  'Show hidden': 'Show hidden',
  'Show symbolic format': 'Show symbolic format',
  'Hide symbolic format': 'Hide symbolic format',
  'Add folder': 'Add folder',
  'successful_failed_total': '{0} successful, {1} failed, {2} total',
  'And N more': '... and {0} more',
  'File conflict title': 'File already exists',
  'Existing file': 'Existing file',
  'New file': 'New file',
  'Apply to remaining conflicts': 'Apply to all remaining conflicts',
  'Skip': 'Skip',
  'Keep both': 'Keep both',
  'Overwrite': 'Overwrite',
  'Upload limit': 'Upload limit',
  'Upload limit help': 'Applies to all users. Files are uploaded in chunks, so this can be larger than the PHP limit.',
  'Current PHP limit': 'Current PHP limit per request: {0}',
  'Value must be at least 1 MB': 'Value must be at least 1 MB',
  'System log': 'System log',
  'Log truncated notice': 'Showing the last {0} lines only. Download the full file for more.',
  'Idle logout message': 'You were automatically logged out due to inactivity.',
  'Security settings': 'Security',
  'Idle logout minutes': 'Auto logout after (minutes of inactivity)',
  'Idle logout minutes help': 'Applies to all users. Between 1 and 120 minutes.',
  'Download link lifetime minutes': 'Download link lifetime (minutes)',
  'Download link lifetime help': 'Download links keep working after logout, until this expires. Between 1 and 1440 minutes.',
  'Lock download link to IP': 'Only usable from the IP that created it',
  'Minutes': 'minutes',
  'Link copied': 'Link copied',
}

export default data

